// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── RichTextEditor (CMDB) ──────────────────────────────────────────────────
   Reutiliza los estilos de tiptap-editor.css y solo ajusta lo que necesita un
   campo de formulario: altura contenida y toolbar compacta con un aviso. */

.cmdb-rte {
  display: block;
  width: 100%;
}

.cmdb-rte-wrap {
  flex: none;
}

.cmdb-rte-loading {
  border: 1px solid var(--border, rgba(255, 255, 255, .12));
  border-radius: 8px;
  padding: 1rem;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
  font-size: 0.85rem;
}

/* El editor de documentación usa 400px de alto mínimo; en un formulario no cabe. */
.cmdb-rte .tiptap-editor-wrap .ProseMirror {
  min-height: 0;
  padding: 0.75rem 0.9rem;
  font-size: 0.9rem;
  line-height: 1.5;
}

.cmdb-rte-canvas {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 420px;
}

.cmdb-rte .tiptap-toolbar button {
  width: 28px;
  height: 26px;
  font-size: 12px;
}

.cmdb-rte-hint {
  margin-left: auto;
  padding-left: 8px;
  font-size: 0.7rem;
  color: var(--text-muted, rgba(255, 255, 255, .45));
  white-space: nowrap;
}

.cmdb-rte .ProseMirror img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}

.cmdb-rte .ProseMirror img.ProseMirror-selectednode {
  outline: 2px solid var(--accent, #6366f1);
}

/* Lista de adjuntos del ticket */
.feedback-attachments {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.feedback-attachments-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.feedback-attachment-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--border, rgba(255, 255, 255, .15));
  border-radius: 999px;
  background: rgba(255, 255, 255, .04);
  font-size: 0.78rem;
  max-width: 100%;
}

.feedback-attachment-chip img {
  width: 22px;
  height: 22px;
  object-fit: cover;
  border-radius: 4px;
}

.feedback-attachment-chip .feedback-attachment-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;
}

.feedback-attachment-chip button {
  border: none;
  background: transparent;
  color: inherit;
  opacity: 0.6;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.feedback-attachment-chip button:hover {
  opacity: 1;
}

.feedback-description-html {
  font-size: 0.9rem;
  line-height: 1.55;
  word-break: break-word;
}

.feedback-description-html img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 0.35rem 0;
}

.feedback-description-html p:last-child {
  margin-bottom: 0;
}

.feedback-description-html a {
  color: var(--accent-l, #818cf8);
}
`, "",{"version":3,"sources":["webpack://./src/components/RichTextEditor.css"],"names":[],"mappings":"AAAA;;2EAE2E;;AAE3E;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yDAAyD;EACzD,kBAAkB;EAClB,aAAa;EACb,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yDAAyD;EACzD,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["/* ── RichTextEditor (CMDB) ──────────────────────────────────────────────────\r\n   Reutiliza los estilos de tiptap-editor.css y solo ajusta lo que necesita un\r\n   campo de formulario: altura contenida y toolbar compacta con un aviso. */\r\n\r\n.cmdb-rte {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.cmdb-rte-wrap {\r\n  flex: none;\r\n}\r\n\r\n.cmdb-rte-loading {\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .12));\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n  font-size: 0.85rem;\r\n}\r\n\r\n/* El editor de documentación usa 400px de alto mínimo; en un formulario no cabe. */\r\n.cmdb-rte .tiptap-editor-wrap .ProseMirror {\r\n  min-height: 0;\r\n  padding: 0.75rem 0.9rem;\r\n  font-size: 0.9rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.cmdb-rte-canvas {\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow-y: auto;\r\n  max-height: 420px;\r\n}\r\n\r\n.cmdb-rte .tiptap-toolbar button {\r\n  width: 28px;\r\n  height: 26px;\r\n  font-size: 12px;\r\n}\r\n\r\n.cmdb-rte-hint {\r\n  margin-left: auto;\r\n  padding-left: 8px;\r\n  font-size: 0.7rem;\r\n  color: var(--text-muted, rgba(255, 255, 255, .45));\r\n  white-space: nowrap;\r\n}\r\n\r\n.cmdb-rte .ProseMirror img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 6px;\r\n}\r\n\r\n.cmdb-rte .ProseMirror img.ProseMirror-selectednode {\r\n  outline: 2px solid var(--accent, #6366f1);\r\n}\r\n\r\n/* Lista de adjuntos del ticket */\r\n.feedback-attachments {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.feedback-attachments-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.feedback-attachment-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  padding: 0.25rem 0.5rem;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .15));\r\n  border-radius: 999px;\r\n  background: rgba(255, 255, 255, .04);\r\n  font-size: 0.78rem;\r\n  max-width: 100%;\r\n}\r\n\r\n.feedback-attachment-chip img {\r\n  width: 22px;\r\n  height: 22px;\r\n  object-fit: cover;\r\n  border-radius: 4px;\r\n}\r\n\r\n.feedback-attachment-chip .feedback-attachment-name {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 220px;\r\n}\r\n\r\n.feedback-attachment-chip button {\r\n  border: none;\r\n  background: transparent;\r\n  color: inherit;\r\n  opacity: 0.6;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0;\r\n}\r\n\r\n.feedback-attachment-chip button:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.feedback-description-html {\r\n  font-size: 0.9rem;\r\n  line-height: 1.55;\r\n  word-break: break-word;\r\n}\r\n\r\n.feedback-description-html img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 6px;\r\n  margin: 0.35rem 0;\r\n}\r\n\r\n.feedback-description-html p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.feedback-description-html a {\r\n  color: var(--accent-l, #818cf8);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
